class LandingPageProduct extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.sectionId = this.dataset.sectionId;
        this.loadingOverlay = this.querySelector('[data-loading-overlay]');
        this.productContent = this.querySelector('[data-product-content]');

        if (this.dataset.maxImageCount) {
            this.maxImageCount = this.dataset.maxImageCount;
        }

        this.init();
    }

    init() {
        console.log('init');
        this.addEventListener('click', this.handleClick.bind(this));
        this.loadProduct(this.productHandle);
    }

    handleClick(event) {
        console.log('handleClick');
        const link = event.target.closest('a[href*="/products/"]');
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href) return;

        event.preventDefault();
        event.stopPropagation();

        const url = new URL(href, window.location.origin);
        const productHandle = url.pathname.split('/products/')[1]?.split('?')[0];
        const variantId = url.searchParams.get('variant');

        if (productHandle) {
            this.loadProduct(productHandle, variantId);
        }
    }

    showLoading() {
        if (this.loadingOverlay) {
            this.loadingOverlay.style.display = 'block';
        }
        this.style.position = 'relative';
    }

    hideLoading() {
        if (this.loadingOverlay) {
            this.loadingOverlay.style.display = 'none';
        }
    }

    async loadProduct(productHandle, variantId = null) {
        this.showLoading();

        try {
            let productUrl = `${window.location.origin}/products/${productHandle}?section_id=${this.sectionId}`;
            if (variantId) {
                productUrl += `&variant=${variantId}`;
            }

            const response = await fetch(productUrl);
            if (!response.ok) throw new Error('Failed to load product');

            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(`#shopify-section-${this.sectionId}`);

            if (this.maxImageCount) {
                const images = Array.from(newContent.querySelectorAll('.product-media-grid__item'));
                images.slice(this.maxImageCount).forEach((img) => {
                    img.remove();
                });
            }

            if (newContent) {
                this.productContent.innerHTML = newContent.innerHTML;

                this.productHandle = productHandle;

                this.dataset.productHandle = this.productHandle;

                this.dispatchEvent(
                    new CustomEvent('landing-page-product:loaded', {
                        bubbles: true,
                        detail: { productHandle, variantId }
                    })
                );
            }
        } catch (error) {
            console.error('Error loading product:', error);
        } finally {
            this.hideLoading();
        }
    }
}

customElements.define('landing-page-product', LandingPageProduct);
